import { boolean, object, optional, string } from 'superstruct';

export const aboutMeConfigSchema = object({
  showAccountBanner: optional(boolean()),
  showOptionsMenu: optional(boolean()),
  healthReportMasonryId: optional(string()),
  showLandingPageBackButton: optional(boolean()),
});
